import React from 'react';
import { Text } from '@goodfynd/ui';

import { GoodfyndSitesStatusPage } from './GoodfyndSitesStatusPage';

import classes from './GoodfyndSitesStatusPage.module.css';

export function GoodfyndSites500() {
  return (
    <GoodfyndSitesStatusPage
      description="Something went wrong while loading this Goodfynd site. Please try again in a moment."
      title="We ran into an unexpected issue."
      // action={{
      //   external: true,
      //   href: 'https://goodfynd.com',
      //   label: 'Go to goodfynd.com',
      // }}
    >
      <Text align="center" className={classes.support}>
        If the problem continues, contact&nbsp;
        <a className={classes.supportLink} href="mailto:support@goodfynd.com">
          support@goodfynd.com
        </a>
        .
      </Text>
    </GoodfyndSitesStatusPage>
  );
}
